"use client";

import { ConversationListFilters } from "@ac-expo/api-types";
import { Checkbox } from "../Checkbox";
import { Popover, PopoverTrigger, PopoverContent } from "../Popover";
import { useIsMobile } from "../../../utils";
import { useState } from "react";
import IconButton from "../IconButton";

export function ConversationFilterPopover({
  filter,
  setFilter,
}: {
  filter: ConversationListFilters;
  setFilter: (filter: {
    exponent: boolean;
    organizer: boolean;
    visitor: boolean;
  }) => void;
}) {
  const isMobile = useIsMobile();

  const [isOpen, setIsOpen] = useState(false);

  return (
    <Popover>
      <PopoverTrigger asChild>
        <IconButton
          svgType="funnel"
          svgProps={{
            size: 24,
            className: "text-primary-500 md:text-gray-500",
          }}
          variant={isMobile ? "outline-white" : "hidden"}
          onClick={() => setIsOpen(!isOpen)}
        />
      </PopoverTrigger>
      <PopoverContent className="flex flex-col gap-2 p-4">
        <div className="flex items-center justify-between rounded-lg border px-4 py-3">
          <label
            htmlFor="exposants"
            className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
          >
            Exposants
          </label>
          <Checkbox
            id="exposants"
            checked={filter.exponent}
            onCheckedChange={() =>
              setFilter({ ...filter, exponent: !filter.exponent })
            }
          />
        </div>
        <div className="flex items-center justify-between rounded-lg border px-4 py-3">
          <label
            htmlFor="organizers"
            className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
          >
            Organisateurs
          </label>
          <Checkbox
            id="organizers"
            checked={filter.organizer}
            onCheckedChange={() =>
              setFilter({ ...filter, organizer: !filter.organizer })
            }
          />
        </div>
        <div className="flex items-center justify-between rounded-lg border px-4 py-3">
          <label
            htmlFor="visitors"
            className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
          >
            Visiteurs
          </label>
          <Checkbox
            id="visitors"
            checked={filter.visitor}
            onCheckedChange={() =>
              setFilter({ ...filter, visitor: !filter.visitor })
            }
          />
        </div>
      </PopoverContent>
    </Popover>
  );
}
